export default { // 该需求运行在浏览器，入口短信短连接进入, 该项目的的访问链接为 inspector-m.shanyishanmei.com/inspector_m/#/vcard,因为该页面接入的为web网关
  tabs: [
    {
      name: 'vcard',
      path: '/vcard',
      component: () => import('./src'),
      meta: {
        title: '电子工牌',
        openNetwork: true // 公开网络可访问
      }
    },
  ]
}
